import { UPDATE_PAYMENT_DATA } from "../actions";
import { isFunction, isPlainObject, isString } from "../../../utils";

const hasProperty = Function.prototype.call.bind(Object.prototype.hasOwnProperty);

export default function __factory__(keys) {
  const $this = this;
  const $unsubscribers = [];

  const REDUCERS = isPlainObject(keys)
    ? Object.keys(keys).reduce((reducersObject, key, index) => {
      if (isString(key)) {
        let keyDefinition = keys[key];

        keyDefinition = (
          isPlainObject(keyDefinition)
            ? keyDefinition
            : isString(keyDefinition) ? { prop: keyDefinition } : {}
        );

        let { prop: reactiveProperty } = keyDefinition;

        if (!((reactiveProperty = reactiveProperty.trim()) && hasProperty($this, reactiveProperty))) {
          throw new Error(
            `Reactive property${
              reactiveProperty ? `(\`${reactiveProperty}\`)` : ''
            } not found for key(\`${key}\`).`
          );
        }

        let initialValue = (
          hasProperty(keyDefinition, 'initialValue')
            ? () => keyDefinition.initialValue
            : () => $this[reactiveProperty]
        )();

        if (initialValue == undefined) {
          initialValue = null;
        }

        const label = `${key}_\$${index}`;

        if (isFunction($this.$subscribe) && isFunction($this.$unsubscribe)) {
          const subscription = function __onChange__(value, oldvalue) {
            value !== oldvalue && $this.dispatch({
              type: UPDATE_PAYMENT_DATA,
              payload: { [label]: value }
            });
          }

          $this.$subscribe(reactiveProperty, subscription);
          $unsubscribers.push(() => $this.$unsubscribe(reactiveProperty, subscription));
        }

        reducersObject[key] = function __updateReducer__(state = initialValue, action) {
          const payload = isPlainObject(action.payload) ? action.payload : {};

          switch (action.type) {
            case UPDATE_PAYMENT_DATA: {
              if (hasProperty(payload, label)) {
                const data = payload[label];
                return data !== state ? data == undefined ? null : data : state;
              }

              return state;
            }

            default: return state;
          }
        }
      }

      return reducersObject;
    }, Object.create(null))
    : Object.create(null);

  return Object.defineProperties(REDUCERS, {
    $unsubscribe: {
      value: function __clearAllSubscriptions__() {
        $unsubscribers.forEach(fn => isFunction(fn) && fn())
      }
    }
  });
}
